module.exports = __webpack_public_path__ + "static/media/fa-users.afe515bc.png";